import React from 'react';
import { ITaggingFlowState } from 'services/helper-services/TaggingFlowStateMachine';
import BaseRunnersOption from '../BaseRunnersOption/BaseRunnersOption';
import FieldingSequenceOption from '../FieldingSequenceOption/FieldingSequenceOption';
import TagCatcherThrows from '../TagCatcherThrows/TagCatcherThrows';
import { OptionsBottomBarWrapper } from './OptionsBottomBarStyles';

interface IProps {
  catcherThrowClickHandler: () => void;
  isCatcherThrowDisabled: boolean;
  fieldingSequenceClickHandler: () => void;
  isFieldingSequenceDisabled: boolean;
  baseRunnersClickHandler: () => void;
  isBaseRunnersDisabled: boolean;
  state: ITaggingFlowState | undefined;
  isPlayerTrackingEnabled: boolean;
}

const OptionsBottomBar: React.FC<IProps> = (props) => {
  const {
    catcherThrowClickHandler,
    isCatcherThrowDisabled,
    fieldingSequenceClickHandler,
    isFieldingSequenceDisabled,
    baseRunnersClickHandler,
    isBaseRunnersDisabled,
    state,
    isPlayerTrackingEnabled,
  } = props;

  return (
    <OptionsBottomBarWrapper>
      {state?.hasCatcherThrows && (
        <TagCatcherThrows
          onClickCallback={catcherThrowClickHandler}
          onPressHotkeyCallback={catcherThrowClickHandler}
          disabled={isCatcherThrowDisabled}
        />
      )}
      {state?.hasFieldingSequence && isPlayerTrackingEnabled && (
        <FieldingSequenceOption
          onClickCallback={fieldingSequenceClickHandler}
          onPressHotkeyCallback={fieldingSequenceClickHandler}
          disabled={isFieldingSequenceDisabled}
        />
      )}
      {state?.hasBaseRunners && isPlayerTrackingEnabled && (
        <BaseRunnersOption
          onClickCallback={baseRunnersClickHandler}
          onPressHotkeyCallback={baseRunnersClickHandler}
          disabled={isBaseRunnersDisabled}
        />
      )}
    </OptionsBottomBarWrapper>
  );
};

export default OptionsBottomBar;
